import { Link } from 'react-router-dom';

const LOGO_URL = 'https://static.readdy.ai/image/461a3833cd00dd501e90f2080ae5acc6/aae23f0a089f1ffcf8ba37bc7395e262.png';

export default function Footer() {
  return (
    <footer className="bg-[#001F4E] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src={LOGO_URL}
              alt="Holston Development Group"
              className="h-10 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-white/70 text-sm leading-relaxed max-w-sm">
              Moving your vision forward. With over 60 years of combined experience, Holston Development Group delivers multi-discipline solutions nationwide.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="mailto:admin@holstondevgroup.com"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#0050B2] transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-sm" />
              </a>
              <a
                href="tel:+14232125009"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#0050B2] transition-colors cursor-pointer"
              >
                <i className="ri-phone-line text-sm" />
              </a>
              <a
                href="https://www.linkedin.com"
                rel="nofollow"
                target="_blank"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#0050B2] transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-sm" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              <a href="#nav" id="nav">Navigation</a>
            </h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">Home</Link></li>
              <li><Link to="/about" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">About Us</Link></li>
              <li><Link to="/contact" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">Contact</Link></li>
            </ul>
          </div>

          {/* Divisions */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              <a href="#divisions" id="divisions">Divisions</a>
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/telecommunications" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">
                  Telecommunications
                </Link>
              </li>
              <li>
                <a
                  href="https://holstonlandmgmt.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-white/70 text-sm hover:text-white transition-colors cursor-pointer"
                >
                  Land Services
                  <i className="ri-external-link-line text-xs" />
                </a>
              </li>
            </ul>
            <div className="mt-6">
              <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-3">Contact</h4>
              <p className="text-white/70 text-sm">admin@holstondevgroup.com</p>
              <p className="text-white/70 text-sm mt-1">(423) 212-5009</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/50 text-xs">
            &copy; {new Date().getFullYear()} Holston Development Group. All rights reserved.
          </p>
          <p className="text-white/50 text-xs">holstondevgroup.com</p>
        </div>
      </div>
    </footer>
  );
}
